import { NavigationConfirmationAlert } from '../../navigationConfirmationAlert';
import { useExtensionsNavigationInterception } from '../../../hooks/useExtensions';

export function ExtensionsNavigationConfirmationAlert() {
  const { navigationConfirmationReasons, clearNavigationConfirmationReasons } =
    useExtensionsNavigationInterception();
  const navigationConfirmationReason = navigationConfirmationReasons[0];
  return (
    <NavigationConfirmationAlert
      alertTextProps={{
        title: navigationConfirmationReason?.title || '',
        description: navigationConfirmationReason?.description || '',
        primaryButtonText: navigationConfirmationReason?.stayButtonText || '',
        secondaryButtonText:
          navigationConfirmationReason?.leaveButtonText || '',
      }}
      shouldBlockNavigation={Boolean(navigationConfirmationReason)}
      onLeave={() => {
        clearNavigationConfirmationReasons();
      }}
      domain='extensions'
      allowClientSideNavigation={
        navigationConfirmationReason?.allowClientSideNavigation
      }
    />
  );
}
